import { Swiper } from "swiper/react";

import { currentDirection } from "@app/lib/helper";
import "swiper/css";

type TabsSliderProps = {
  children: React.ReactNode;
};

export function TabsSlider({ children }: TabsSliderProps) {
  const dir = currentDirection();

  return (
    <Swiper
      className="w-full transition-none"
      slidesPerView="auto"
      spaceBetween={8}
      dir={dir}
      key={dir}
    >
      {children}
    </Swiper>
  );
}
